import { Button } from '@material-ui/core';
import styled from 'styled-components';

export default styled(Button)`
  margin: 12px auto;
  width: 500px;
  max-width: 90%;
  height: 55px;
`;
